import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import { Field, Control, Label, Icon } from "rbx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useQuery } from "react-apollo";
import { ALL_SYSTEM_CODES_QUERY } from "../../graphql/SystemCodes/SystemCodes.graphql";

const SystemCodeMultipleSelect = ({
  value: initialValue,
  onChange = console.log,
  onBlur = console.log,
  showLabel = true,
  name,
  required = false,
  readOnly = false,
  label,
  lookup,
  icon,
  showBlank
}) => {
  const [selected, setSelected] = useState([]);
  const [options, setOptions] = useState([]);
  const { data = { SystemCodes: [] }, loading } = useQuery(
    ALL_SYSTEM_CODES_QUERY,
    {
      variables: {
        where: {
          Category: lookup.Category,
          CodeName: lookup.Code,
          CodeDescription_not: lookup.not || ""
        },
        orderByMulti: ["ListOrder_ASC", "CodeDescription_ASC"]
      }
    }
  );

  const handleChange = value => {
    setSelected(value);
    onChange({
      target: {
        name,
        type: "select",
        value: Array.isArray(value) ? value.map(v => v.value) : null
      }
    });
  };

  useEffect(() => {
    if (Array.isArray(initialValue)) {
      const newValue = options.filter(opt =>
        initialValue.some(x => opt.value === x)
      );
      setSelected(newValue);
    }
  }, [initialValue, options]);

  useEffect(() => {
    if (
      !data.loading &&
      options.length === 0 &&
      data.SystemCodes &&
      data.SystemCodes.length > 0
    ) {
      const result = data.SystemCodes.map(({ RecId, CodeDescription }) => ({
        value: RecId,
        label: CodeDescription
      }));
      setOptions(
        showBlank ? [{ label: "Blank", value: null }, ...result] : result
      );
    }
  }, [data.SystemCodes, data.loading, options.length, showBlank]);

  const handleBlur = () => {
    onBlur({
      target: {
        name,
        type: "select",
        value: Array.isArray(selected) ? selected.map(v => v.value) : null
      }
    });
  };
  return (
    <Field>
      {showLabel && <Label>{label}</Label>}
      <Control iconLeft={!!icon}>
        <Select
          isMulti
          menuPortaalTa
          closeMenuOnSelect={false}
          disabled={readOnly}
          isLoading={loading}
          menuPlacement="auto"
          menuPortalTarget={document.body}
          name={name}
          options={options}
          required={required}
          styles={{
            menuPortal: provided => ({
              ...provided,
              zIndex: 9999
            }),
            menu: provided => ({
              ...provided,
              zIndex: 999
            })
          }}
          value={selected}
          onBlur={handleBlur}
          onChange={handleChange}
        />
        {icon && (
          <Icon align="left">
            <FontAwesomeIcon icon={icon} />
          </Icon>
        )}
      </Control>
    </Field>
  );
};

SystemCodeMultipleSelect.propTypes = {
  value: PropTypes.array,
  onChange: PropTypes.func,
  showLabel: PropTypes.bool,
  onBlur: PropTypes.func,
  name: PropTypes.string,
  required: PropTypes.bool,
  readOnly: PropTypes.bool,
  label: PropTypes.string,
  lookup: PropTypes.object,
  icon: PropTypes.string,
  showBlank: PropTypes.bool
};
SystemCodeMultipleSelect.defaultProps = {
  required: false
};
export default SystemCodeMultipleSelect;
